import backendUrl from "./backendUrl";

export const productApi = {
  uploadProduct: {
    url: `${backendUrl}/api/upload-product`,
    method: "post",
  },
  allProduct: {
    url: `${backendUrl}/api/get-product`,
    method: "get",
  },
  updateProduct: {
    url: `${backendUrl}/api/update-product`,
    method: "put",
  },
  deleteProduct: {
    url: `${backendUrl}/api/delete-product`,
    method: "delete",
  },
  categoryProduct: {
    url: `${backendUrl}/api/get-categoryProduct`,
    method: "get",
  },
  categoryWiseProduct: {
    url: `${backendUrl}/api/category-product`,
    method: "get",
  },
  productDetails: {
    url: `${backendUrl}/api/product-details`,
    method: "post",
  },
  searchProduct: {
    url: `${backendUrl}/api/search`,
    method: "get",
  },
  filterProduct: {
    url: `${backendUrl}/api/filter-product`,
    method: "get",
  },
  removeBackground: {
    url: `${backendUrl}/api/remove-background`,
    method: "post",
  },
  addToBgQueue: {
    url: `${backendUrl}/api/add-to-bg-queue`,
    method: "post",
  },
  bgQueueStatus: {
    url: `${backendUrl}/api/bg-queue-status`,
    method: "get",
  },
  saleProducts: {
    url: `${backendUrl}/api/sale-products`,
    method: "get",
  },
  getAllBrands: {
    url: `${backendUrl}/api/get-all-brands`,
    method: "get",
  },
  backfillStock: {
    url: `${backendUrl}/api/product-backfill-stock`,
    method: "post",
  },
  featuredProducts: {
    url: `${backendUrl}/api/featured-products`,
    method: "get",
  },
  getBrandsPublic: {
    url: `${backendUrl}/api/get-brands-public`,
    method: "get",
  },
};
